import React, { useState } from "react";
import Layout from '../form-layout';

// Q9 — "Have you been diagnosed with any OTHER health conditions?" A "Yes" here just
// flags the case for doctor review (Amber) via computeFinalTier(); it doesn't reject.
export default function Step8d({ formData, setFormData, onBack, goToStep }) {
  const [hasOtherCondition, setHasOtherCondition] = useState(
    formData.hasOtherCondition || localStorage.getItem("hasOtherCondition") || ""
  );
  const [otherConditionDetails, setOtherConditionDetails] = useState(
    formData.otherConditionDetails || localStorage.getItem("otherConditionDetails") || ""
  );

  const handleSelection = (value) => {
    setHasOtherCondition(value);
    localStorage.setItem("hasOtherCondition", value);
    setFormData((prev) => ({ ...prev, hasOtherCondition: value }));
  };

  const handleInputChange = (value) => {
    setOtherConditionDetails(value);
    localStorage.setItem("otherConditionDetails", value);
    setFormData((prev) => ({ ...prev, otherConditionDetails: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (hasOtherCondition === "Yes" && !otherConditionDetails.trim()) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      hasOtherCondition,
      otherConditionDetails,
      otherMedicalConditionsAnswer: hasOtherCondition,
    }));

    localStorage.setItem("hasOtherCondition", hasOtherCondition);
    localStorage.setItem("otherMedicalConditionsAnswer", hasOtherCondition);

    goToStep("9");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <div className="bg-white w-full max-w-xl px-6 sm:px-8 pt-2 pb-16 sm:pb-20">
        <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-3">
          Have you been diagnosed with any OTHER health conditions?
        </h2>
        <p className="text-gray-600 text-sm leading-relaxed mb-6">
          To ensure your GLP-1 prescription is completely safe, our medical team requires your full
          health history. Please detail any conditions not covered on the previous pages, including
          relevant recent blood test results (with approximate dates) if available.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex gap-6">
            {["No", "Yes"].map((option) => {
              const isSelected = hasOtherCondition === option;
              return (
                <label key={option} className="inline-flex items-center cursor-pointer p-2 transition">
                  <input
                    type="radio"
                    name="hasOtherCondition"
                    value={option}
                    checked={isSelected}
                    onChange={() => handleSelection(option)}
                    className="form-radio h-4 w-4 accent-[#35C3D9] mr-2"
                  />
                  <span className="text-gray-800">{option}</span>
                </label>
              );
            })}
          </div>

          {hasOtherCondition === "Yes" && (
            <textarea
              value={otherConditionDetails}
              onChange={(e) => handleInputChange(e.target.value)}
              placeholder="Please describe your condition and any current treatment."
              className="mt-3 border border-gray-300 rounded-lg p-3 w-full min-h-[80px] text-sm focus:outline-none focus:ring-2 focus:ring-[#35C3D9] focus:border-transparent"
            />
          )}

          <div className="flex justify-start mt-6">
            <button
              type="submit"
              disabled={!hasOtherCondition || (hasOtherCondition === "Yes" && !otherConditionDetails.trim())}
              className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
                ${
                  !hasOtherCondition || (hasOtherCondition === "Yes" && !otherConditionDetails.trim())
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
                }`}
            >
              Next →
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
